import { render, staticRenderFns } from "./dutyorderdetails.vue?vue&type=template&id=98efc9be&scoped=true&"
import script from "./dutyorderdetails.vue?vue&type=script&lang=js&"
export * from "./dutyorderdetails.vue?vue&type=script&lang=js&"
import style0 from "./dutyorderdetails.vue?vue&type=style&index=0&id=98efc9be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98efc9be",
  null
  
)

export default component.exports